import * as React from 'react';

import type {ListOption} from 'shells/select-option-components/option';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import {useGetDripSequences} from '../../graphql-wrappers/drip-sequence/graphql/hooks/use-get-drip-sequences';

type Props = {
    onChange: (option: ListOption) => void;
    selectedId: string | null | undefined;
};

export function SelectEmDripSequence(props: Props): React.ReactElement {
    const {dripSequences, loading} = useGetDripSequences({
        sort: 'NAME_ASC',
        statuses: ['ACTIVE'],
        archived: false,
        limit: 1000,
    });

    const options: ListOption[] = React.useMemo(() => {
        if (!dripSequences || !dripSequences.edges) {
            return [];
        }

        return dripSequences.edges.map((edge) => ({
            value: edge.node.id,
            label: edge.node.name,
        }));
    }, [dripSequences]);

    const selectedOption = props.selectedId
        ? options.find((option) => option.value === props.selectedId)
        : null;

    return (
        <SelectPickerGeneric
            options={options}
            value={selectedOption}
            onChange={props.onChange}
            isLoading={loading}
            placeholder='Select a drip sequence'
            menuPlacement='bottom'
        />
    );
}
